var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "aftersale-shippingList print-font" }, [
    _c("div", { staticClass: "main" }, [
      _c(
        "div",
        { staticClass: "print-font" },
        [
          _c("div", { staticClass: "title" }, [_vm._v("售后发货清单")]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                model: _vm.shippingForm,
                "label-position": "left"
              }
            },
            [
              _c("el-form-item", { attrs: { label: "服务编号:" } }, [
                _vm._v(_vm._s(_vm.shippingForm.main_number))
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "发货日期:" } }, [
                _vm._v(_vm._s(_vm.shippingForm.date))
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("el-form-item", { attrs: { label: "收货方:" } }, [
                    _vm._v(_vm._s(_vm.shippingForm.user_name))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.shippingTableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "sku", label: "商品编码" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "商品名称" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "unit", label: "单位" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "returned_num", label: "数量" }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "btn" },
      [
        _c(
          "el-button",
          {
            attrs: { type: "primary", size: "small" },
            on: { click: _vm.myPrint }
          },
          [_vm._v("打印")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-771cc5aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-771cc5aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bigAftersale/aftersale-shipping-list.vue
// module id = null
// module chunks = 